import {
  DRAWER_ADD_TO_CART,
  PDP_ADD_TO_CART,
  PDP_CLICK_ON_APPLY,
  RELEASE_TOGGLE_VARIANT_ATTRIBUTES,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import { bindDynamicEventsTracking } from 'shared/experiments/utils/tracking'

const pdpAddToCartAndApplyTracking = () =>
  bindDynamicEventsTracking([
    {
      parentElementSelector: '#h_ProductVariants',
      selector: '#AddToCartButton',
      trackingEvent: PDP_ADD_TO_CART,
    },
    {
      parentElementSelector: '#applyButtonWrapper',
      selector: '#applyButtonOnPDP',
      trackingEvent: PDP_CLICK_ON_APPLY,
    },
    {
      parentElementSelector: '.o-BuyBoxSticky__wrapper-price',
      selector: '[data-clientside-hook="chargeUrlSearchParams"]',
      trackingEvent: DRAWER_ADD_TO_CART,
    },
  ])

export default async () => {
  const { isEnabled } =
    getExperimentOnClient(RELEASE_TOGGLE_VARIANT_ATTRIBUTES) || {}

  if (!isEnabled) {
    return
  }
  await activateExperiment(RELEASE_TOGGLE_VARIANT_ATTRIBUTES)

  pdpAddToCartAndApplyTracking()
}
